import { FC, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { addPatientInfo } from "Redux/Patient/Action";
import { useDispatch } from "react-redux";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";

type IconProps = {
  sxProps?: any;
  title: React.ReactNode;
  icon: JSX.Element;
  tooltipDelay?: number;
  autoTooltipDisplay?: boolean;
};

const CstmTooltip: FC<IconProps> = (props: IconProps) => {
  const { tooltipDelay, icon, title, sxProps, autoTooltipDisplay } = props;
  const dispatch = useDispatch();
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (autoTooltipDisplay && patientInfo.firstTimeNotesVisit) {
      setTooltipOpen(true);
      const timer = setTimeout(() => {
        setTooltipOpen(false);
        dispatch(
          addPatientInfo({ ...patientInfo, firstTimeNotesVisit: false })
        );
      }, tooltipDelay);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [autoTooltipDisplay, patientInfo.firstTimeNotesVisit]);

  return (
    <Tooltip
      open={tooltipOpen}
      onClose={() => setTooltipOpen(false)}
      onOpen={() => setTooltipOpen(true)}
      title={title}
      arrow
      sx={sxProps}
      enterDelay={autoTooltipDisplay ? 0 : undefined}
    >
      {icon}
    </Tooltip>
  );
};

export default CstmTooltip;
